/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxItemChannel = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type MailboxItemChannel = typeof MailboxItemChannel[keyof typeof MailboxItemChannel];


export function instanceOfMailboxItemChannel(value: any): boolean {
    for (const key in MailboxItemChannel) {
        if (Object.prototype.hasOwnProperty.call(MailboxItemChannel, key)) {
            if (MailboxItemChannel[key as keyof typeof MailboxItemChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxItemChannelFromJSON(json: any): MailboxItemChannel {
    return MailboxItemChannelFromJSONTyped(json, false);
}

export function MailboxItemChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemChannel {
    return json as MailboxItemChannel;
}

export function MailboxItemChannelToJSON(value?: MailboxItemChannel | null): any {
    return value as any;
}

export function MailboxItemChannelToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxItemChannel {
    return value as MailboxItemChannel;
}

